module.exports = __webpack_public_path__ + "static/media/voterfied.dbec7f40.png";